import { config, getAuthToken } from './bridge.js';

const BASE = `${config.backendUrl.replace(/\/$/, '')}/api/teenpatti`;

async function authedFetch(path, options = {}) {
  const token = await getAuthToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  let body = null;
  try { body = await res.json(); } catch (e) {}
  if (!res.ok) {
    const err = new Error((body && body.error) || `http_${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const api = {
  getConfig: () => authedFetch('/config'),
  getBalance: () => authedFetch('/balance'),
  getCurrentRound: () => authedFetch('/round/current'),
  getRound: (id) => authedFetch(`/round/${id}`),
  getHistory: (limit = 20) => authedFetch(`/history?limit=${limit}`),
  getLeaderboard: (limit = 5) => authedFetch(`/leaderboard?limit=${limit}`),
  getMyBets: (limit = 30) => authedFetch(`/my-bets?limit=${limit}`),
  /**
   * Place one stake. The server debits atomically and is the only thing that
   * decides whether the bet is in time — the client's countdown is advisory.
   * `clientNonce` makes a retry safe: the same nonce debits at most once.
   */
  bet: ({ roundId, frameId, amount, clientNonce }) =>
    authedFetch('/bet', {
      method: 'POST',
      body: JSON.stringify({ roundId, frameId, amount, clientNonce }),
    }),
};

/** Unique-enough nonce for one tap; scoped per round by the server. */
export function makeNonce() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
